import { useEffect, useState } from 'react';

import { authService, UserSession } from '@/services/auth-service';
import { User } from '@/types/models';

export function useAuth() {
	const [session, setSession] = useState<UserSession | null>(null);
	const [user, setUser] = useState<User | null>(null);
	const [authError, setAuthError] = useState<string | null>(null);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		// Get initial state
		const loadInitialState = async () => {
			const currentSession = await authService.getSession();
			const currentUser = await authService.getUser();
			const currentError = authService.getAuthError();

			setSession(currentSession);
			setUser(currentUser);
			setAuthError(currentError);
			setIsLoading(false);
		};

		loadInitialState();

		// Set up listeners
		const unsubscribeSession = authService.onSessionChange(setSession);
		const unsubscribeUser = authService.onUserChange(setUser);
		const unsubscribeError = authService.onAuthError(setAuthError);

		return () => {
			unsubscribeSession();
			unsubscribeUser();
			unsubscribeError();
		};
	}, []);

	return {
		session,
		user,
		authError,
		isLoading,
		signIn: authService.signIn.bind(authService),
		signInWithApple: authService.signInWithApple.bind(authService),
		signOut: authService.signOut.bind(authService),
		refreshTokens: authService.refreshTokens.bind(authService),
		setAuthError: authService.setAuthError.bind(authService),
		assumeUser: authService.assumeUser.bind(authService),
		isImpersonating: authService.isImpersonating.bind(authService),
		endImpersonation: authService.endImpersonation.bind(authService),
	};
}
